export default "__VITE_ASSET__BeWS$BS7__"